export class Tuple<T1, T2> {
  item1: T1 | undefined;
  item2: T2 | undefined;

  constructor(item1: T1 | undefined = undefined, item2: T2 | undefined = undefined) {
    this.item1 = item1;
    this.item2 = item2;
  }
}
